import React from "react";
import { motion } from "framer-motion";
import "./Contact.css";
import { FaPhoneAlt } from "react-icons/fa";

const Contact = () => {
  const offices = [
    {
      name: "Rajshahi Office",
      address: "216/1, Talaimari, Kajla, Boalia, Rajshahi-6204",
      mobile: "+8801321141781-90",
      mapSrc:
        "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7269.216117122027!2d88.624395!3d24.360142!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x39fbef00627d4f99%3A0xe73eeb888ab08b14!2sShunno%20IT%20Rajshahi%20Office!5e0!3m2!1sen!2sbd!4v1736765179560!5m2!1sen!2sbd"
    },
    {
      name: "Dhaka Office",
      address: "272/5, West Agargaon, Sher-e-Bangla Nagar, Dhaka-1207",
      mobile: "+8801321141781-90",
      mapSrc:
        "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7302.07039102795!2d90.371354!3d23.781761!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c15e9f448fe7%3A0xea077001b58b5803!2sShunno%20IT%20Dhaka%20Office!5e0!3m2!1sen!2sbd!4v1736765283738!5m2!1sen!2sbd"
    }
  ];
  const cardAnimation = {
    hidden: { opacity: 0, y: 30 },
    visible: (customDelay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.3, delay: customDelay, ease: "easeOut" }
    })
  };

  const cardAnimationSupport = {
    hidden: { opacity: 0, y: 30, scale: 0.97 },
    visible: (customDelay = 0) => ({
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.3, delay: customDelay, ease: "easeOut" }
    })
  };
  return (
    <section id="contact" className="container mt-3 pt-3 mb-5">
      <motion.h1
        style={{ color: "#a44cee", fontSize: "2.8rem" }}
        className="text-center fw-bolder my-5"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        viewport={{ once: true }}
      >
        Feel <span className="text-color">Free To Contact Us</span>
      </motion.h1>

      <div className="my-5 text-center" style={{ fontSize: "30px" }}>
        <FaPhoneAlt className="me-2 " />{" "}
        <span className="fw-bolder">
          01896192221, 01896192225 & 01896192229
        </span>
      </div>

      <div className="d-flex flex-column flex-lg-row gap-5">
        {offices?.map((office, index) => (
          <motion.div
            key={index}
            className="bg-white rounded-4 p-4 hover-shadow card-hover-scale w-100"
            style={{ border: "1px #942ce9ff solid" }}
            custom={index * 0.05}
            initial="hidden"
            whileInView="visible"
            variants={cardAnimation}
            viewport={{ once: true }}
          >
            <div className="text-center">
              <h2 style={{ color: "#a44cee" }} className="h3 fw-bold mb-3">
                {office.name}
              </h2>

              <p style={{ color: "#a44cee" }} className="text-muted mb-2">
                {/* <span className="fw-semibold">Office Address:</span> <br /> */}
                <span className="text-black fw-semibold  ">
                  {office.address}
                </span>
              </p>

              <p style={{ color: "#a44cee" }} className="text-muted mb-3">
                <span className="fw-semibold me-2 text-black">Mobile:</span>
                <span className="text-black fw-semibold  ">
                  {office.mobile}
                </span>
              </p>
            </div>

            <iframe
              src={office.mapSrc}
              width="100%"
              height="150"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              className="rounded"
            />
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default Contact;
